/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据年份获取节假日
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class FindHolidaysByYearOrMoonParams {
  constructor(public month?: string) {}
}

export default async function (
  year: string,

  params: FindHolidaysByYearOrMoonParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.Holidays>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/holidays/${year}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
